import { render, staticRenderFns } from "./PastEvents.vue?vue&type=template&id=1654722f&"
import script from "./PastEvents.vue?vue&type=script&lang=js&"
export * from "./PastEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports